import {createFileRoute, notFound} from "@tanstack/react-router";
import {AdminModuleDocPage} from "~/components/adminDocs/adminModuleDocPage";
import {getAdminModuleDoc} from "~/domainModels/adminDocs/adminModuleDocsRegistry";
import {ErrorComponent} from "../-errorComponent";
import {NotFoundComponent} from "../-notFoundComponent";
import {PendingComponent} from "../-pendingComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/docs/$moduleSlug",
)({
    loader: async ({context, params}) => {
        const moduleDoc = getAdminModuleDoc(params.moduleSlug);
        if (moduleDoc === null) {
            throw notFound();
        }

        return {
            moduleDoc,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});

function RouteComponent() {
    const {moduleDoc, intellsysBaseUrl, accessToken} = Route.useLoaderData();

    return (
        <AdminModuleDocPage
            moduleDoc={moduleDoc}
            intellsysBaseUrl={intellsysBaseUrl}
            accessToken={accessToken}
        />
    );
}
